<script>
import { mapGetters } from 'vuex';
import { useVuelidate } from '@vuelidate/core';
import { useAlert } from 'dashboard/composables';
import { required } from '@vuelidate/validators';
import router from '../../../../index';
import { isPhoneE164OrEmpty, isNumber } from 'shared/helpers/Validators';

import { loadScript } from 'dashboard/helper/DOMHelpers';

export default {
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      inboxName: '',
      phoneNumber: '',
      apiKey: '',
      phoneNumberId: '',
      businessAccountId: '',
      advanced: false,
      fbAppId: window.globalConfig?.FB_APP_ID || '',
      fbApiVersion: window.globalConfig?.FACEBOOK_API_VERSION || '',
      fbSDKLoaded: false,
      isSignupInProgress: false,
      facebookEmbeddedConfigId: window.chatwootConfig?.facebookEmbeddedConfigId || '',
      waba_id: '',
      status: 'Aguarde...'
    };
  },
  mounted() {
    if (this.handleEmbeddedSignupMessage) {
      window.addEventListener('message', this.handleEmbeddedSignupMessage);
    } else {
    }
  },
  beforeDestroy() {
    window.removeEventListener('message', this.handleEmbeddedSignupMessage);
  },
  unmounted() {
    window.removeEventListener('message', this.handleEmbeddedSignupMessage);
  },
  computed: {
    ...mapGetters({ uiFlags: 'inboxes/getUIFlags' }),
  },
  validations: {
    inboxName: { required },
    phoneNumber: { required, isPhoneE164OrEmpty },
    apiKey: { required },
    phoneNumberId: { required, isNumber },
    businessAccountId: { required, isNumber },
  },
  methods: {
    async createChannel() {
      this.v$.$touch();
      if (this.v$.$invalid) {
        return;
      }

      try {
        const whatsappChannel = await this.$store.dispatch(
          'inboxes/createChannel',
          {
            name: this.inboxName,
            channel: {
              type: 'whatsapp',
              phone_number: this.phoneNumber,
              provider: 'whatsapp_cloud',
              provider_config: {
                api_key: this.apiKey,
                phone_number_id: this.phoneNumberId,
                business_account_id: this.businessAccountId,
              },
            },
          }
        );

        router.replace({
          name: 'settings_inboxes_add_agents',
          params: {
            page: 'new',
            inbox_id: whatsappChannel.id,
          },
        });
      } catch (error) {
        useAlert(
          error.message || this.$t('INBOX_MGMT.ADD.WHATSAPP.API.ERROR_MESSAGE') +
          '\n detail:' +
          error
        );
      }
    },
    runFBInit() {
      FB.init({
        appId: window.chatwootConfig.fbAppId,
        autoLogAppEvents: true,
        xfbml: true,
        version: window.chatwootConfig.fbApiVersion,
        status: true,
      });
      window.fbSDKLoaded = true;
      // FB.AppEvents.logPageView();
    },

    async loadFBsdk() {
      return loadScript('https://connect.facebook.net/en_US/sdk.js', {
        id: 'facebook-jssdk',
      });
    },

    async startLogin() {
      try {
        if (this.isSignupInProgress) return;


        if (!window.fbSDKLoaded) {
          await this.loadFBsdk();
          this.runFBInit();
          useAlert('Carregado com sucesso !');
          this.isSignupInProgress = true;


          window.FB.login(this.fbLoginCallback, {
            config_id: `${this.facebookEmbeddedConfigId}`,
            response_type: 'code',
            override_default_response_type: true,
            extras: {
              "version": "v3",
              "featureType": "whatsapp_business_app_onboarding",
              "features": [
                { "name": "marketing_messages_lite" },
                { "name": "app_only_install" }
              ],
              "sessionInfoVersion": "3"
            }
          });
        }
      } catch (err) {
        console.error(err);
      }
    },

    fbLoginCallback(response) {
      console.log(response);
      if (response.authResponse) {
        const { authResponse, status } = response;
        useAlert(`Facebook: ${status}`);
        const { code } = authResponse;
        if (code) {
          this.exchangeCodeForToken(code);
        }
      } else {
        this.isSignupInProgress = false;
        useAlert('A autenticação foi cancelada ou falhou.');
      }
    },

    async exchangeCodeForToken(authCode) {
      try {

        useAlert("Aguarde um momento estamos finalizando ...")
        this.status = "Finalizando..."
        const accountId = this.$route.params.accountId;
        const userToken = this.$store.getters['getCurrentUser'].access_token;

        const response = await window.axios.post(`/api/v1/accounts/${accountId}/whatsapp/exchange_token`, {
          code: authCode
        },
          {
            headers: {
              'api_key': userToken,
            }
          });

        console.log(response);

        if (response?.data && response?.data?.access_token) {
          useAlert("Conexão com Meta validada com sucesso !");
          const { access_token } = response?.data;
          this.apiKey = access_token;
        }
      } catch (error) {
        console.group("Erro na Troca de Token WhatsApp");
        let userMessage = "Erro ao validar a conexão com o Facebook.";
        if (error.response && error.response.data) {
          const backendData = error.response.data;
          if (backendData.error) {
            userMessage = backendData.error;
          }
          if (backendData.details) {
            console.error("Detalhes da Meta:", backendData.details);
            if (backendData.details.error && backendData.details.error.message) {
              userMessage += ` Detalhe: ${backendData.details.error.message}`;
            }
          }
        } else {
          console.error("Erro inesperado:", error);
        }

        console.groupEnd();
        useAlert(userMessage);

        this.apiKey = '';
      } finally {
        this.isSignupInProgress = false;
      }

      await this.fetchPhoneNumber(this.waba_id, this.apiKey);
      this.isSignupInProgress = false;
    },

    async showModalWhatsAppBusiness() {
      const url = window?.chatwootConfig?.whatsAppRegistrationEmbedded;

      if (!url || url === '' || url === 'nil') {
        useAlert("URL de cadastro não configurado. Verifique com suporte !")
        return;
      }

      this.isSignupInProgress = true;

      const width = 600;
      const height = 750;

      const left = window.screen.width / 2 - width / 2;
      const top = window.screen.height / 2 - height / 2;

      const popup = window.open(
        url,
        'WhatsAppEmbeddedSignup',
        `width=${width},height=${height},top=${top},left=${left},scrollbars=yes,resizable=yes`
      );

      const timer = setInterval(() => {
        if (popup.closed) {
          clearInterval(timer);
          this.isSignupInProgress = false;
        }
      }, 1000);
    },

    handleEmbeddedSignupMessage(event) {
      if (!event.origin.includes('facebook.com')) {
        return;
      }

      try {
        let data = event.data;

        if (typeof data === 'string') {
          try {
            data = JSON.parse(data);
          } catch (e) {
            return;
          }
        }

        if (data.type === 'WA_EMBEDDED_SIGNUP') {
          useAlert("Buscando dados da conta !");

          if (data.event === 'FINISH') {
            const { phone_number_id, waba_id, business_id } = data.data;
            this.waba_id = waba_id;
            this.businessAccountId = waba_id;
            //this.phoneNumberId = business_id;
            this.phoneNumberId = phone_number_id;
            this.status = 'Aguarde...';
          }
          else if (data.event === 'CANCEL') {
            useAlert("O usuário fechou o popup antes de terminar.");
            this.isSignupInProgress = false;
          }
        }
        else if (data.type === 'ERROR') {
          console.error('Erro Meta:', data);
          useAlert(`Erro: ${data.error_message || 'Desconhecido'}`);
        }

      } catch (err) {
        console.error("Erro ao processar mensagem do Facebook:", err);
      }
    },

    async fetchPhoneNumber(waba_id, access_token) {
      const url = `https://graph.facebook.com/${window.chatwootConfig.fbApiVersion}/${waba_id}/phone_numbers?fields=id,cc,country_dial_code,display_phone_number,verified_name,status,quality_rating,search_visibility,platform_type,code_verification_status&access_token=${access_token}`;
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-type": "application/json"
        }
      });
      const data = await response.json();
      console.log(data);
      if (data && data?.data) {
        const { display_phone_number, verified_name } = data?.data[0];
        this.phoneNumber =  `${display_phone_number.replace(/[^\d+]/g, '')}`;
        this.inboxName = verified_name;
      }
    }
  },


}
</script>

<template>
  <form class="flex flex-wrap mx-0" @submit.prevent="createChannel()">

    <div class="w-[65%] flex-shrink-0 flex-grow-0 max-w-[65%]">
      <label :class="{ error: v$.inboxName.$error }">
        {{ $t('INBOX_MGMT.ADD.WHATSAPP.INBOX_NAME.LABEL') }}
        <input v-model.trim="inboxName" type="text" :placeholder="$t('INBOX_MGMT.ADD.WHATSAPP.INBOX_NAME.PLACEHOLDER')"
          @blur="v$.inboxName.$touch" />
        <span v-if="v$.inboxName.$error" class="message">
          {{ $t('INBOX_MGMT.ADD.WHATSAPP.INBOX_NAME.ERROR') }}
        </span>
      </label>
    </div>

    <div class="w-[65%] flex-shrink-0 flex-grow-0 max-w-[65%]">
      <label :class="{ error: v$.phoneNumber.$error }">
        {{ $t('INBOX_MGMT.ADD.WHATSAPP.PHONE_NUMBER.LABEL') }}
        <input v-model.trim="phoneNumber" type="text"
          :placeholder="$t('INBOX_MGMT.ADD.WHATSAPP.PHONE_NUMBER.PLACEHOLDER')" @blur="v$.phoneNumber.$touch" />
        <span v-if="v$.phoneNumber.$error" class="message">
          {{ $t('INBOX_MGMT.ADD.WHATSAPP.PHONE_NUMBER.ERROR') }}
        </span>
      </label>
    </div>

    <div class="w-[65%] flex-shrink-0 flex-grow-0 max-w-[65%]">
      <label :class="{ error: v$.phoneNumberId.$error }">
        <span>
          {{ $t('INBOX_MGMT.ADD.WHATSAPP.PHONE_NUMBER_ID.LABEL') }}
        </span>
        <input v-model.trim="phoneNumberId" type="text" :placeholder="$t('INBOX_MGMT.ADD.WHATSAPP.PHONE_NUMBER_ID.PLACEHOLDER')
          " @blur="v$.phoneNumberId.$touch" />
        <span v-if="v$.phoneNumberId.$error" class="message">
          {{ $t('INBOX_MGMT.ADD.WHATSAPP.PHONE_NUMBER_ID.ERROR') }}
        </span>
      </label>
    </div>

    <div class="w-[65%] flex-shrink-0 flex-grow-0 max-w-[65%]">
      <label :class="{ error: v$.businessAccountId.$error }">
        <span>
          {{ $t('INBOX_MGMT.ADD.WHATSAPP.BUSINESS_ACCOUNT_ID.LABEL') }}
        </span>
        <input v-model.trim="businessAccountId" type="text" :placeholder="$t('INBOX_MGMT.ADD.WHATSAPP.BUSINESS_ACCOUNT_ID.PLACEHOLDER')
          " @blur="v$.businessAccountId.$touch" />
        <span v-if="v$.businessAccountId.$error" class="message">
          {{ $t('INBOX_MGMT.ADD.WHATSAPP.BUSINESS_ACCOUNT_ID.ERROR') }}
        </span>
      </label>
    </div>

    <div class="w-[65%] flex-shrink-0 flex-grow-0 max-w-[65%]">
      <label :class="{ error: v$.apiKey.$error }">
        <span>
          {{ $t('INBOX_MGMT.ADD.WHATSAPP.API_KEY.LABEL') }}
        </span>
        <input v-model.trim="apiKey" type="text" :placeholder="$t('INBOX_MGMT.ADD.WHATSAPP.API_KEY.PLACEHOLDER')"
          @blur="v$.apiKey.$touch" />
        <span v-if="v$.apiKey.$error" class="message">
          {{ $t('INBOX_MGMT.ADD.WHATSAPP.API_KEY.ERROR') }}
        </span>
      </label>
    </div>

    <div class="w-full">
      <woot-submit-button :loading="uiFlags.isCreating" :button-text="$t('INBOX_MGMT.ADD.WHATSAPP.SUBMIT_BUTTON')" />
    </div>

    <div class="relative flex items-center mt-10 w-[65%] flex-shrink-0 flex-grow-0 max-w-[65%]">
      <div class="flex-grow border-t border-slate-200"></div>
      <div class="w-full text-center">
        <span class="flex-shrink mx-4 text-slate-400 text-[11px] font-bold uppercase tracking-widest">
          Cadastro incorporado Provedor de soluções
        </span>
      </div>
    </div>

    <div class="w-[65%] flex-shrink-0 flex-grow-0 max-w-[65%] mt-5">
      <div class="p-6 border border-slate-200 rounded-xl bg-white shadow-sm">

        <div class="flex items-center gap-4 mb-6">
          <div class="flex items-center justify-center w-12 h-12 rounded-lg bg-blue-50 text-blue-600">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
              class="lucide lucide-rocket">
              <path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z" />
              <path
                d="m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z" />
              <path d="M9 12H4s.55-3.03 2-5c1.62-2.2 5-3 5-3l1 1" />
              <path d="M12 15v5s3.03-.55 5-2c2.2-1.62 3-5 3-5l-1-1" />
            </svg>
          </div>
          <div class="flex flex-col justify-center">
            <p class="mt-3 text-[10px] text-slate-400 uppercase tracking-wider font-medium">
              Início do Cadastro incorporado
            </p>
            <p class="text-sm !text-slate-800 !opacity-100 m-0 mt-1">
              Siga o flow Cadastro incorporado para compartilhar uma conta do WhatsApp e receber o token.
            </p>
          </div>
        </div>

        <div class="h-[1px] bg-slate-100 w-full mb-6"></div>

        <div class="flex flex-row gap-4 w-full">

          <button type="button" @click="startLogin()" :disabled="isSignupInProgress"
            class="flex-1 flex items-center justify-center gap-2 px-4 py-3 bg-[#1877F2] text-white font-bold rounded-lg hover:bg-[#166fe5] transition-all shadow-md active:scale-95 disabled:opacity-50">
            <i v-if="!isSignupInProgress" class="ion-social-facebook text-xl"></i>
            <i v-else class="ion-load-c anim-spin text-xl"></i>
            <span class="truncate">{{ isSignupInProgress ? this.status : 'Facebook Via SDK' }}</span>
          </button>

          <!-- <button type="button" @click="showModalWhatsAppBusiness()" :disabled="isSignupInProgress"
            class="flex-1 flex items-center justify-center gap-2 px-4 py-3 bg-[#075E54] text-white font-bold rounded-lg hover:bg-[#128C7E] transition-all shadow-md active:scale-95 disabled:opacity-50">
            <i v-if="!isSignupInProgress" class="ion-social-whatsapp text-xl"></i>
            <i v-else class="ion-load-c anim-spin text-xl"></i>
            <span class="truncate">{{ isSignupInProgress ? 'Aguarde...' : 'Via Business' }}</span>
          </button> -->

        </div>

        <p class="mt-3 text-[10px] text-slate-400 uppercase tracking-wider font-medium">
          Conexão segura via Meta Enterprise
        </p>
      </div>

    </div>
  </form>
</template>
